import React from 'react'
import {NavigationButtonHelper} from 'lib/Helpers/NavigationButton';
import ParallaxBackground from '../../Widgets/ParallaxBackground';
import BlockArrowWidget from 'components/Widgets/Buttons/BlockArrow.widget';
const $ = window.$;



class NewAboutPage extends React.Component {

    componentDidMount () {
        // NavigationButtonHelper.showBackButton();
        NavigationButtonHelper.setColor({primaryColor:'rgba(0,0,0,0.3)'});
    }

    slideBack () {
		//todo: move this up a higher level =
		if ($('.transitioning').length > 0) {
			return;
		}
		this.props.history.goBack()
	}

	render() {
        const { parallaxConfiguration, content } = this.props;
        const headerText = content.header
        const paragraphText = content.paragraph
		return (
			<div className="page-newabout">
                <ParallaxBackground parallaxConfiguration={parallaxConfiguration}/>
                <BlockArrowWidget  clickHandler={() => this.slideBack()}/>
                <div className="dark-overlay"></div>
                <div className="content">
                   
                    <p1>
                    {paragraphText}
                        </p1>
                </div>
                <div className='overlay'>
                    
                </div>
                {/* <div className='subject-page-button'>About</div> */}
                <div className="fadeout"></div>
			</div>
		);
	}
}

export default NewAboutPage